import React, { useCallback, useEffect, useState } from 'react';
import { Col, Label, Row, Spinner } from 'reactstrap';
import api from "../../../../services/api";

const apiUrl = "employeechangeconditionv2";

export default function ECCApprovalDetail (props) {
    const {id} = props;
    const [loading, setLoading] = useState(false);
    const [items, setItems] = useState([]);
    const [currentItem, setCurrentItem] = useState(null);

    const loadData = useCallback(() => {
        if (!id)
            return;

        setLoading(true);

        api.get(`${apiUrl}/${id}/approvals`)
            .then((response) => {
                const {data} = response;
                setItems([
                    ...data.map(d => {
                        return {
                            value: d.eccApprovalId,
                            label: d.approverName,
                            disabled: true,
                            current: d.statusName.toLowerCase().includes("pending"),
                            approverName: d.approverName,
                            approverRole: d.approverRole,
                            status: d.statusName,
                            inProgress: d.statusName.toLowerCase().includes("pending") || d.statusName.toLowerCase().includes("queue")
                        };
                    })
                ]);

                setCurrentItem(data.filter(d => d.statusName.toLowerCase().includes("pending"))[0] ?? null);
            })
            .catch((error) => console.error({error}))
            .finally(() => setLoading(false))
        ;
    }, [id]);

    useEffect(() => {
        if (!id)
            return;

        loadData();
    }, [id]);

    const sidebarStyle = { height: "3px", backgroundColor: "#aaa" };

    return (
        <>
        {
            loading ? <div className="w-100 d-flex flex-wrap justify-content-center align-items-center"><Spinner color="default" type="border"  style={{ width: `1.5rem`, height: `1.5rem`, borderWidth: `0.2rem` }} /></div> : null
        }
            <div className="w-100 d-flex flex-wrap justify-content-start align-items-start">
            {
                items.map((i, idx) => {
                    const iconName = i.current && i.inProgress ? "map-marker-alt" : (i.status.toLowerCase().includes("reject") || i.status.toLowerCase().includes("decline") ? "ban": (i.status.toLowerCase().includes("approve") || i.status.toLowerCase().includes("accept") ? "check" : "ellipsis-h"));

                    return (
                        <div key={`item_${idx}`} className="d-flex flex-wrap justify-content-center align-items-start" style={{minWidth: "150px"}}>
                            <Row className="m-0 p-0 w-100" style={{height: "40px"}}>
                                <Col xs={4} className="m-0 p-0 d-flex flex-wrap justify-content-center align-items-center">
                                {
                                    idx > 0 ?
                                    <div className="w-100" style={sidebarStyle}></div>
                                    :
                                    null
                                }
                                </Col>
                                <Col xs={4} className="m-0 p-0 d-flex flex-wrap justify-content-center align-items-center">
                                    <div className={`stepper-item-circle stepper-item-${i.current && i.inProgress ? "current" : (i.status.toLowerCase().includes("reject") || i.status.toLowerCase().includes("decline") ? "rejected": (i.status.toLowerCase().includes("approve") || i.status.toLowerCase().includes("accept") ? "approved" : "next"))} d-flex flex-wrap justify-content-center align-items-center`}>
                                        <i className={`fas fa-${iconName}`} />
                                    </div>
                                </Col>
                                <Col xs={4} className="m-0 p-0 d-flex flex-wrap justify-content-center align-items-center">
                                {
                                    idx + 1 < items.length ?
                                    <div className="w-100" style={sidebarStyle}></div>
                                    :
                                    null
                                }
                                </Col>
                            </Row>
                            <Row className="m-0 p-0 w-100">
                                <Col xs={12} className="m-0 p-0 d-flex flex-column justify-content-center align-items-center">
                                    <Label className="font-size-small-custom m-0"><b>{ i.approverName }</b></Label>
                                    <Label className="font-size-small-custom m-0"><b>{ i.approverRole }</b></Label>
                                    <Label className="font-size-small-custom m-0">{ i.status }</Label>
                                </Col>
                            </Row>
                        </div>
                    );
                })
            }
            </div>
        </>
    );
}
